import { SUPPORTED_CRYPTOS } from '@/features/api/coinone/getCryptoCurrentPrice';

export const sortOrders = [
  '최신순',
  '위험도 낮은 순',
  '점수 높은 순',
  '최근 3개월 수익률 높은 순',
  '누적 거래대금 높은 순',
  '누적 손익 높은 순',
] as const;

export const styleFilters = [
  '하이리스크 하이리턴',
  '로우리스크 로우리턴',
] as const;

export const marketFilters = [...SUPPORTED_CRYPTOS] as const;

export const minPrincipalFilters = [
  '100만 원 미만',
  '100만 원 이상 300만 원 미만',
  '300만 원 이상 1000만 원 미만',
  '1000만 원 이상',
] as const;
